import messages from './auth.messages';
import { ROUTES } from '../../routes/routes';

export const LOGIN_TAB = 'login';
export const REGISTER_TAB = 'register';
export const RESET_PASSWORD_TAB = 'resetPassword';
export const RESET_PASSWORD_TAB_SUCCESS = 'resetPasswordSuccess';

export const AuthModalTypes = [LOGIN_TAB, REGISTER_TAB, RESET_PASSWORD_TAB, RESET_PASSWORD_TAB_SUCCESS];

export const REGISTRATION_FIELDS = {
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  password: 'password',
  agreements1: 'marketingAgreement',
  agreements2: 'agreements2',
};

export const LOGIN_FIELDS = {
  email: 'email',
  password: 'password',
};

export const RESET_PASSWORD_FIELDS = {
  email: 'email',
};

export const CHANGE_PASSWORD_FIELDS = {
  password: 'password',
};

export const FIREBASE_AUTH_ERRORS = {
  'auth/weak-password': {
    fieldName: REGISTRATION_FIELDS.password,
    message: messages.weakPassword,
  },
  'auth/email-already-in-use': {
    fieldName: REGISTRATION_FIELDS.email,
    message: messages.emailAlreadyInUse,
  },
  'auth/wrong-password': {
    fieldName: LOGIN_FIELDS.password,
    message: messages.incorrectPassword,
  },
  'auth/user-not-found': {
    fieldName: LOGIN_FIELDS.email,
    message: messages.userNotFound,
  },
  'auth/expired-action-code': {
    fieldName: CHANGE_PASSWORD_FIELDS.password,
    message: messages.codeExpired,
  },
  'auth/argument-error': {
    fieldName: CHANGE_PASSWORD_FIELDS.password,
    message: messages.codeExpired,
  },
  'auth/requires-recent-login': {
    fieldName: RESET_PASSWORD_FIELDS.email,
    message: messages.reSignInNeeded,
  },
  'auth/invalid-action-code': {
    fieldName: CHANGE_PASSWORD_FIELDS.password,
    message: messages.resetPasswordLinkIsInactive,
  },
};

export const PROFILE_FIELDS = [
  REGISTRATION_FIELDS.email,
  REGISTRATION_FIELDS.firstName,
  REGISTRATION_FIELDS.lastName,
  REGISTRATION_FIELDS.agreements1,
];

export const getFirebaseAuthErrorMessage = ({ code }) => {
  const { fieldName, message } = FIREBASE_AUTH_ERRORS[code] || {};

  if (fieldName) {
    return { [fieldName]: message };
  }

  return {};
};

export const CHANGE_PASSWORD_AUTH_MODE = 'resetPassword';

export const AUTH_MODES = [CHANGE_PASSWORD_AUTH_MODE];

export const AUTH_MODES_ROUTES = {
  [CHANGE_PASSWORD_AUTH_MODE]: ROUTES.auth.changePassword.base,
};

export const PAYMENT_FIELDS = {
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
};
